import { NavLink, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CONFIGURATIONS_RECEIVING_SETTINGS, CONFIGURATIONS_RECEIVING_OVERRIDES, CONFIGURATIONS_RECEIVING_HISTORY } from '../../../navigation/constants'

const TABS = [
  { key: 'settings', href: CONFIGURATIONS_RECEIVING_SETTINGS },
  { key: 'overrides', href: CONFIGURATIONS_RECEIVING_OVERRIDES },
  { key: 'history', href: CONFIGURATIONS_RECEIVING_HISTORY },
]

export const ReceivingTabs = () => {
  const { warehouse_id } = useParams()
  const { t } = useTranslation()
  return (
    <div className="border-b border-gray-200 bg-white">
      <nav className="-mb-px flex space-x-6 px-4" aria-label="Receiving tabs">
        {TABS.map(tab => (
          <NavLink
            key={tab.key}
            to={tab.href.replace(':warehouse_id', warehouse_id)}
            className="whitespace-nowrap py-3 px-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
            activeClassName="border-yellow-500 text-yellow-600"
          >
            {t(`receiving_config.tabs.${tab.key}`)}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
